import axios, { AxiosInstance } from 'axios';
import AddressResponse from '../models/interfaces/AddressResponse';

export default class AddressService {
  public static axios: AxiosInstance;
  public static baseURL: string = 'https://viacep.com.br/ws/';

  public static async getAddressByCEP(cep: string): Promise<AddressResponse> {
    this.axios = axios.create({ baseURL: this.baseURL });
    try {
      const address: AddressResponse = (await this.axios.get<AddressResponse>(`/${cep}/json/`)).data;
      return address;
    } catch (error) {
      throw error.response.data;
    }
  }
}
